import { confirmDialog } from './confirmDialog';
import * as notifications from './notifications/index';

export default { confirmDialog, ...notifications };
